import type { Label } from "./check-in-queries";

/**
 * What a label prints (ADR 0042 §4): the child's label and the guardian's tag, and for an adult a name tag. No
 * birthdate, no notes: a label is read by strangers. Browser print CSS (station.css) prints only this block.
 */
export function Labels({ labels }: { labels: readonly Label[] }) {
  return (
    <div className="checkin-labels" data-testid="labels">
      {labels.map((l) => (
        <div key={l.checkInId} className="checkin-label-pair">
          <div className="checkin-label">
            <div className="checkin-label-name">
              {l.firstName} {l.lastInitial}.
            </div>
            {l.room === null ? null : <div className="checkin-label-room">{l.room}</div>}
            <div className="checkin-label-codes">
              <span>{l.labelCode}</span>
              {l.isChild ? <span className="checkin-label-security">{l.securityCode}</span> : null}
            </div>
            <div className="checkin-label-event">
              {l.event} ·{" "}
              {new Date(l.startsAt).toLocaleDateString(undefined, {
                day: "numeric",
                month: "short",
              })}
            </div>
          </div>
          {l.isChild ? (
            <div className="checkin-label checkin-tag">
              <div className="checkin-label-security checkin-tag-code">{l.securityCode}</div>
              <div className="checkin-label-event">
                {l.firstName} · {l.labelCode} · guardian&apos;s tag
              </div>
            </div>
          ) : null}
        </div>
      ))}
    </div>
  );
}
